var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "grid",
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("defs", [
        _c(
          "pattern",
          {
            attrs: {
              id: "smallGrid",
              width: _vm.smallGridW,
              height: _vm.smallGridH,
              patternUnits: "userSpaceOnUse",
            },
          },
          [
            _c("path", {
              attrs: {
                d: _vm.smallGridPathD,
                fill: "none",
                stroke: "rgba(207, 207, 207, 0.3)",
                "stroke-width": "1",
              },
            }),
          ]
        ),
        _c(
          "pattern",
          {
            attrs: {
              id: "middleGrid",
              width: _vm.middleGridW,
              height: _vm.middleGridH,
              patternUnits: "userSpaceOnUse",
            },
          },
          [
            _c("rect", {
              attrs: {
                width: _vm.middleGridW,
                height: _vm.middleGridH,
                fill: "url(#smallGrid)",
              },
            }),
            _c("path", {
              attrs: {
                d: _vm.middleGridPathD,
                fill: "none",
                stroke: "rgba(207, 207, 207, 0.3)",
                "stroke-width": "1.5",
              },
            }),
          ]
        ),
        _c(
          "pattern",
          {
            attrs: {
              id: "grid",
              width: _vm.gridW,
              height: _vm.gridH,
              patternUnits: "userSpaceOnUse",
            },
          },
          [
            _c("rect", {
              attrs: {
                width: _vm.gridW,
                height: _vm.gridH,
                fill: "url(#middleGrid)",
              },
            }),
            _c("path", {
              attrs: {
                d: _vm.pathD,
                fill: "none",
                stroke: "rgba(207, 207, 207, 0.7)",
                "stroke-width": "2.5",
              },
            }),
          ]
        ),
      ]),
      _c("rect", {
        attrs: { width: "100%", height: "100%", fill: "url(#grid)" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }